import React from "react";
import Quizpage from './Quizpage'
import Form from './Form'
import Home from './Home'

function App() {
  return (
    <div className="App">
      <Home />
      <Form />
    </div>
  );
}

export default App;
